import React from 'react';

const PermissionFormModal = React.lazy(() => import('../components/FormModal'));
const permissionModalRegistry = {
    core_permissionId: PermissionFormModal
};
export default permissionModalRegistry;
